import { render, staticRenderFns } from "./WaitingRoomPreview.vue?vue&type=template&id=2db9f25d&"
import script from "./WaitingRoomPreview.vue?vue&type=script&lang=ts&"
export * from "./WaitingRoomPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports